import type { FormField } from '../../../types/formTypeStructure';
import { useFormStore } from '../../../store/useFormStore';
import { showToast } from '../../../utils/toastHelpers';

export function useFormReset(
  resetForm: (values?: Record<string, any>) => void,
  allFields: FormField[],
  formId: string,
  navigation: any
) {
  const handleClearAll = () => {
    try {
      // 1. Créer des valeurs vides
      const defaultValues = Object.fromEntries(
        allFields.map((field) => [
          field.fieldName,
          field.fieldType === 'checkbox' ? [] : ''
        ])
      );

      // 2. Marquer que le formulaire a été supprimé
      localStorage.setItem('form-cleared-' + formId, 'true');

      // 3. Supprimer du localStorage
      localStorage.removeItem('multi-form-drafts');

      // 4. Réinitialiser le store Pinia
      const formStore = useFormStore();
      formStore.clearAll();

      // 5. Réinitialiser Vee-Validate avec valeurs vides
      resetForm({ values: defaultValues });

      // 6. Mettre les valeurs vides dans le store sans sauvegarder
      formStore.forms[formId] = defaultValues;

      // 7. Navigation forcée à la première section
      setTimeout(() => {
        navigation.goToFirst();
      }, 0);

      // 8. Vérifier que la suppression a bien fonctionné
      setTimeout(() => {
        const remainingData = formStore.getFormValues(formId);
        const allEmpty = Object.values(remainingData).every(val => 
          val === '' || val === null || val === undefined || 
          (Array.isArray(val) && val.length === 0)
        );
        
        if (allEmpty) {
          showToast('🗑️ Toutes les données ont été supprimées avec succès ! Le formulaire a été réinitialisé.', 'success');
          console.log('✅ Form cleared successfully:', formId);
          
          // Nettoyer le marqueur de suppression pour permettre de nouvelles saisies
          localStorage.removeItem('form-cleared-' + formId);
          
          // Forcer une nouvelle réinitialisation du formulaire pour s'assurer de la cohérence
          resetForm({ values: defaultValues });
        } else {
          showToast('❌ Une erreur est survenue lors de la suppression des données. Veuillez réessayer.', 'error');
          console.log('❌ Suppression échouée');
        }
      }, 100);
    } catch (error) {
      console.error('❌ Error clearing form:', error);
      showToast('❌ Erreur lors de la suppression des données', 'error');
    }
  };

  return { handleClearAll };
}

